<template>
	<div class="about">
		<div class="pg-header">
			<div style="display: flex; align-items: center;">
				<label class="title">找患者</label>
				<!-- F 25.5.22 随访不显示同步时间 -->
				<p class="utime" v-if="queryType != 4">最近一次同步时间{{ updateTime }}</p>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>
						{{ {
							0: '院中管理', 2: '出院排期管理', 1: '门诊排期管理', 4: '随访管理'
						}[queryType] }}
					</span>|
					<span>找患者</span>
				</div>
			</div>
		</div>
		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px" v-if="queryType == 0">
					<div class="def-key">
						<div>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter0.name"
								@keyup.enter.native="handleFilter0(0, $event)"></el-input></div>
						<div>住院号<el-input size="small" maxlength="18" style="width:80px"
								v-model.trim="filter0.admissionNumber"
								@keyup.enter.native="handleFilter0(1, $event)"></el-input></div>
						<div>身份证号<el-input size="small" maxlength="18" style="width:180px"
								v-model.trim="filter0.cardNum"
								@keyup.enter.native="handleFilter0(1, $event)"></el-input></div>
					</div>
					<div class="def-key">
						<div>入院时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter0.date"
								:picker-options="pickerOptions" @change="handleFilter0(2, $event)"></el-date-picker>
						</div>
						<div>科室
							<el-select size="small" filterable clearable placeholder="请选择"
								v-model="filter0.inHospitalDepartmentId" @change="handleFilter0(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter0">搜索</el-button>
					</div>
				</el-form>
				<el-form ref="form" label-width="120px" v-if="queryType == 2 || queryType == 1">
					<div class="def-key">
						<div>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter2.name"
								@keyup.enter.native="handleFilter2(0, $event)"></el-input></div>
						<div>住院号<el-input size="small" maxlength="18" style="width:80px"
								v-model.trim="filter2.admissionNumber"
								@keyup.enter.native="handleFilter2(1, $event)"></el-input></div>
						<div>身份证号<el-input size="small" maxlength="18" style="width:180px"
								v-model.trim="filter2.cardNum"
								@keyup.enter.native="handleFilter2(1, $event)"></el-input></div>
					</div>
					<div class="def-key">
						<div>{{ { 1: '就诊', 2: '出院' }[queryType] }}时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter2.date"
								:picker-options="pickerOptions" @change="handleFilter2(2, $event)"></el-date-picker>
						</div>
						<div>科室
							<el-select size="small" filterable clearable placeholder="请选择"
								v-model="filter2.outHospitalDepartmentId" @change="handleFilter2(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter2">搜索</el-button>
					</div>
				</el-form>

				<el-form ref="form" label-width="120px" v-if="queryType == 4">
					<div class="def-key">
						<div>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter4.name"
								@keyup.enter.native="handleFilter4(0, $event)"></el-input></div>
						<div>住院号<el-input size="small" maxlength="18" style="width:80px"
								v-model.trim="filter4.admissionNumber"
								@keyup.enter.native="handleFilter4(1, $event)"></el-input></div>
						<div>身份证号<el-input size="small" maxlength="18" style="width:180px"
								v-model.trim="filter4.cardNum"
								@keyup.enter.native="handleFilter4(1, $event)"></el-input></div>
						<div style="display: inline-block;">来源
							<el-select size="small" filterable clearable placeholder="请选择" v-model="filter4.datasources"
								@change="handleFilter4(4, $event)">
								<el-option label="出院" :value="Number(2)"></el-option>
								<el-option label="门诊" :value="Number(1)"></el-option>
							</el-select>
						</div>
					</div>
					<div class="def-key">
						<div>{{ { 1: '就诊', 2: '出院' }[filter4.datasources] }}日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter4.date"
								:picker-options="pickerOptions" @change="handleFilter4(2, $event)"></el-date-picker>
						</div>
						<div>应随访日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter4.date1"
								:picker-options="pickerOptions" @change="handleFilter4(3, $event)"></el-date-picker>
						</div>

						<div>科室
							<el-select size="small" filterable clearable placeholder="请选择"
								v-model="filter4.hospitalDepartmentIds" @change="handleFilter4(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter4">搜索</el-button>
					</div>
				</el-form>
			</div>
		</div>
		<div class="collapse-wrap">
			<div class="table-wrap">
				<h1 v-if="queryType !== 4">已抓取</h1>
				<Tables childType='captured' />
			</div>
		</div>
		<div class="collapse-wrap" v-if="queryType !== 4">
			<div class="table-wrap">
				<h1>未抓取</h1>
				<Tables childType='notCaptured' />
			</div>
		</div>

	</div>
</template>

<script>
import api from '@/service/api.js';
import utils from '@/service/utils';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
import Tables from './components/tables.vue';
import { EventBus } from '@/event-bus.js';

export default {
	mixins: [mixin],
	components: { Tables },

	data() {
		return {
			deptList: [],
			queryType: null,
			updateTime: '',
			filter0: {},
			filter2: {},
			filter4: {}
		}
	},

	computed: {
		// 根据查询类型返回对应的过滤器
		currentFilter() {
			return this[`filter${this.queryType}`] || {};
		},
	},

	created() {
		this.initFilters();
		this.initRouteQuery();
		this.watchRouteChanges();
		this.initData();
	},

	methods: {
		// 初始化所有过滤器
		initFilters() {
			this.filter0 = this.createFilter0();
			this.filter2 = this.createFilter2();
			this.filter4 = this.createFilter4();
		},

		// 创建院中管理过滤器
		createFilter0() {
			return {
				name: '',
				cardNum: '',
				admissionNumber: '',
				inHospitalDepartmentId: '',
				diseaseManagerId: '',
				inHospitalDiagnosis: '',
				recordState: null,
				orderCondition: 1,
				orderConditionList: [
					{ id: 1, name: '入院时间' },
					{ id: 2, name: '床号正序' }
				],
				orderRule: 2,
				orderRuleList: [
					{ id: 1, name: '正序' },
					{ id: 2, name: '倒序' }
				],
				pageNumber: 1,
				pageSize: 10
			};
		},

		// 创建出院/门诊过滤器
		createFilter2() {
			return {
				name: '',
				cardNum: '',
				outHospitalCloseDateStart: '',
				outHospitalCloseDateEnd: '',
				outHospitalDepartmentId: '',
				outHospitalDiagnosis: '',
				schedulingState: '',
				data: [],
				showMyself: false,
				pageNumber: 1,
				pageSize: 10,
				datasources: null,
				updateDateStart: '',
				updateDateEnd: '',
				updateDate: [],
				admissionNumber: '',
			};
		},

		// 创建随访过滤器
		createFilter4() {
			return {
				name: '',
				cardNum: '',
				expectFollowupDateStart: '',
				expectFollowupDateEnd: '',
				hospitalDepartmentIds: '',
				selectedDepartmentIdList: [],
				outHospitalDiagnosisName: '',
				followupState: '',
				date: [],
				date1: [],
				pageNumber: 1,
				pageSize: 10,
				updateDateStart: '',
				updateDateEnd: '',
				updateDate: [],
				valid: '',
				notValidReason: '',
				hasRemark: '',
				hasQuestionContent: '',
				tagId: '',
				datasources: null,
				showMyself: false,
				admissionNumber: ''
			};
		},

		// 初始化路由查询参数
		initRouteQuery() {
			const query = this.$route.query;
			this.queryType = Number(query.dataType);

			if (query.admissionNumber || query.name || query.cardNum) {
				this.handleQueryParams(query);
			}

			if (query.datasources) {
				this.filter4.datasources = Number(query.datasources);
			}
		},

		// 处理查询参数
		handleQueryParams(query) {
			const fields = ['admissionNumber', 'name', 'cardNum'];

			fields.forEach(field => {
				if (query[field]) {
					this.setFilterField(field, query[field]);
				}
			});
		},

		// 设置过滤器字段值
		setFilterField(field, value) {
			const filterMap = {
				0: 'filter0',
				1: 'filter2',
				2: 'filter2',
				4: 'filter4'
			};

			const filterName = filterMap[this.queryType];
			if (filterName && this[filterName]) {
				this[filterName][field] = value;
			}
		},

		// 监听路由变化
		watchRouteChanges() {
			this.$watch(
				() => this.$route.query,
				(newQuery) => {
					this.queryType = Number(newQuery.dataType);
					this.resetFilters(newQuery);
					// 延迟执行 initData，确保查询参数已经设置完成
					this.$nextTick(() => {
						this.initData();
					});
				}
			);
		},

		// 重置过滤器
		resetFilters(newQuery) {
			this.filter0 = this.createFilter0();
			this.filter2 = { ...this.createFilter2(), datasources: Number(newQuery.dataType) };
			this.filter4 = {
				...this.createFilter4(),
				datasources: newQuery.datasources ? Number(newQuery.datasources) : null
			};

			// 立即处理查询参数，不需要等待下一个 tick
			if (newQuery.admissionNumber || newQuery.name || newQuery.cardNum) {
				this.handleQueryParams(newQuery);
			}
		},

		// 初始化数据
		initData() {
			this.loadDeptList();
			this.loadSyncTime();
			this.loadList();
		},

		// 加载科室列表
		async loadDeptList() {
			const deptTypeMap = {
				0: 0, // 院中
				1: 1, // 门诊
				2: 0, // 出院
				4: null // 随访 - 不传参数
			};

			const departmentType = deptTypeMap[this.queryType];
			const params = departmentType !== null ? { departmentType } : {};

			try {
				const res = await api.getDeptDropdown(params);
				if (res.code === 1000 && res.data) {
					this.deptList = res.data;
				}
			} catch (error) {
				console.error('加载科室列表失败:', error);
			}
		},

		// 加载同步时间
		async loadSyncTime() {
			try {
				const res = await api.getInterfaceSyncDate();
				if (res.code === 1000 && res.data) {
					const syncData = res.data.find(item => item.returnResult == this.queryType);
					this.updateTime = syncData?.syncTime || '';
				}
			} catch (error) {
				console.error('加载同步时间失败:', error);
			}
		},

		// 加载列表数据
		loadList() {
			this.queryType = Number(this.queryType);

			const filterMap = {
				0: this.filter0,
				1: { ...this.filter2, datasources: 1 },
				2: { ...this.filter2, datasources: 2 },
				4: this.filter4
			};

			const currentFilter = filterMap[this.queryType];
			if (currentFilter) {
				EventBus.$emit('update-filter', currentFilter);
			}
		},

		// 统一的过滤处理方法
		handleFilter(filterType, key, val) {
			const filter = this[`filter${filterType}`];
			if (!filter) return;

			this.processFilterKey(filter, key, val);
			filter.pageNumber = 1;
			this.loadList();
		},

		// 处理过滤器键值
		processFilterKey(filter, key, val) {
			switch (key) {
				case 2: // 日期处理
					this.handleDateFilter(filter, val);
					break;
				case 3: // 随访日期处理
					this.handleFollowupDateFilter(filter, val);
					break;
			}
		},

		// 处理日期过滤
		handleDateFilter(filter, val) {
			const dateField = filter.date;
			if (dateField) {
				if (filter === this.filter0) {
					filter.inHospitalDateStart = dayjs(dateField[0]).format('YYYY-MM-DD 00:00:00');
					filter.inHospitalDateEnd = dayjs(dateField[1]).format('YYYY-MM-DD 23:59:59');
				} else if (filter === this.filter2) {
					filter.outHospitalCloseDateStart = dayjs(dateField[0]).format('YYYY-MM-DD 00:00:00');
					filter.outHospitalCloseDateEnd = dayjs(dateField[1]).format('YYYY-MM-DD 23:59:59');
				} else if (filter === this.filter4) {
					filter.outHospitalTimeStart = dayjs(dateField[0]).format('YYYY-MM-DD 00:00:00');
					filter.outHospitalTimeEnd = dayjs(dateField[1]).format('YYYY-MM-DD 23:59:59');
				}
			} else {
				this.clearDateFields(filter);
			}
		},

		// 处理随访日期过滤
		handleFollowupDateFilter(filter, val) {
			if (filter.date1) {
				filter.expectFollowupDateStart = dayjs(filter.date1[0]).format('YYYY-MM-DD 00:00:00');
				filter.expectFollowupDateEnd = dayjs(filter.date1[1]).format('YYYY-MM-DD 23:59:59');
			} else {
				filter.expectFollowupDateStart = '';
				filter.expectFollowupDateEnd = '';
			}
		},

		// 清空日期字段
		clearDateFields(filter) {
			if (filter === this.filter0) {
				filter.inHospitalDateStart = '';
				filter.inHospitalDateEnd = '';
			} else if (filter === this.filter2) {
				filter.outHospitalCloseDateStart = '';
				filter.outHospitalCloseDateEnd = '';
			} else if (filter === this.filter4) {
				filter.outHospitalTimeStart = '';
				filter.outHospitalTimeEnd = '';
			}
		},

		// 各类型的过滤处理方法
		handleFilter0(key, val) {
			this.handleFilter(0, key, val);
		},

		handleFilter2(key, val) {
			this.handleFilter(2, key, val);
		},

		handleFilter4(key, val) {
			this.handleFilter(4, key, val);
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';

::v-deep .el-select-dropdown__list {
	width: 260px;
}

.utime {
	padding: 4px 12px;
	border: 1px solid #FBFBFB;
	// .search-bar{
	// 	.el-form{
	// 		display: flex;
	// 	}
	// }
}
</style>